/*
 *
 * PageState reducer
 *
 */

import { fromJS } from "immutable";
import * as CONSTANTS from "./constants";

export const initialState = fromJS({
  // When a user edits a timeSlot from the newTreatment page this is used to
  // go back to the newTreatment page using the correct state.
  treatmentFromTimeSlot: null,
});

function pageStateReducer(state = initialState, action) {
  switch (action.type) {
    case CONSTANTS.SET_TREATMENT_TIME_SLOT:
      return state.set("treatmentFromTimeSlot", action.value);
    default:
      return state;
  }
}

export default pageStateReducer;
